import request from "../../assets/js/Request.js";
// 获取精彩瞬间
export const getMomentsList = (params) => {
    return request.post("getMomentsList", params);
  };